export default "__VITE_ASSET__BTy2ktS6__"